import { EReportColumnHeader } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { TGlobalMetrics } from '../../../models'

export const spMetricNames: Array<TGlobalMetrics> = [
  EReportColumnHeader.Impressions,
  EReportColumnHeader.Clicks,
  EReportColumnHeader.Ctr,
  EReportColumnHeader.Costs,
  EReportColumnHeader.Cpc,
  EReportColumnHeader.ShareOfVoice,
  EReportColumnHeader.WinRate,
  EReportColumnHeader.AvgRank,
  EReportColumnHeader.Carts,
  EReportColumnHeader.Purchases,
  EReportColumnHeader.Revenue,
  EReportColumnHeader.Roas,
  EReportColumnHeader.NewToBrandPurchases,
  EReportColumnHeader.NewToBrandRevenue,
  EReportColumnHeader.ConversionRate,
]
